var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { useRoute } from 'ziggy-js';
import moment from 'moment';
import Breadcrumb from '@/Jetstream/Breadcrumb';
import ClientFields from './Partials/ClientFields';
import handleUnsavedChanges from "../../Utils/handleUnsavedChanges";
import CertificateRow from "../Certificate/Partials/CertificateRow";
import { PetCard, PetCardForm } from "../Pet/Partials/PetCard";
import uniques from "../../Utils/uniques";
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import JetModal from '@/Jetstream/Modal';
import ClientFormModal from '../ClientForm/Partials/ClientFormModal';
import _ from 'lodash';
import useTypedPage from "@/Hooks/useTypedPage";
import axios from "axios";
import useForm from "@/Utils/useForm";
import { Ziggy } from "@/ziggy";
export default function Show(_a) {
    var _b, _c, _d, _e;
    var team = _a.team, branch = _a.branch, client = _a.client, permissions = _a.permissions, colours = _a.colours, breeds = _a.breeds;
    var route = useRoute(Ziggy);
    var init = __assign({}, client);
    var page = useTypedPage();
    var form = useForm(init);
    var petForm = useForm({
        _modal: true,
    });
    handleUnsavedChanges(form);
    function submit() {
        form.put(route('team.branch.client.update', { team: team, branch: branch, client: client }), {
            errorBag: 'update',
            preserveScroll: true,
            onSuccess: function (page) {
                form.setData(page.props.client);
            }
        });
    }
    function deletePet(petIdx) {
        if (confirm("Are you sure you want to delete ".concat(client.pets[petIdx].name, "?"))) {
            form.delete(route('team.branch.client.pet.destroy', { team: team, branch: branch, client: client, pet: client.pets[petIdx] }), {
                preserveScroll: true,
                onSuccess: function () {
                    client.pets = client.pets.slice(petIdx);
                    forceUpdate();
                }
            });
        }
    }
    function onPetChange(pet) {
        // console.log('onPetChange...', pet);
        // if (pet.id === '_NEW_') {
        //     setPetModelCounter(petModelCounter + 1);
        //     petForm.setData({
        //         _modal: true,
        //     })
        //     setOpen(true);
        // } else {
        //     form.data.certificate_pets.push({
        //         pet_id: pet.id,
        //         pet: pet
        //     });
        //     form.data.certificate_pets = uniques(form.data.certificate_pets);
        //     form.setData('certificate_pets', form.data.certificate_pets);
        // }
    }
    function onPetPanelClose() {
        var _a, _b;
        setOpen(false);
        if (((_b = (_a = form.data) === null || _a === void 0 ? void 0 : _a.pet) === null || _b === void 0 ? void 0 : _b.id) === '_NEW_') {
            form.setData('pet', null);
        }
    }
    var _f = useReducer(function (x) { return x + 1; }, 0), ignored = _f[0], forceUpdate = _f[1];
    function onPetUpdate(data) {
        console.log('onPetUpdate...', data);
        form.data.pets.push(data);
        form.data.pets = uniques(form.data.pets);
        form.setData('pets', form.data.pets);
    }
    function removePet(idx) {
        console.log('removePet', idx);
        form.data.pets.splice(idx, 1);
        form.setData('pets', form.data.pets);
        if (client.pets[idx].id) {
            axios.delete(route('team.branch.client.pet.destroy', { team: team, branch: branch, client: client, pet: client.pets[idx] }));
        }
    }
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var petInit = {};
    var _h = useState(petInit), petModel = _h[0], setPetModel = _h[1];
    var _j = useState({}), newClientForm = _j[0], setNewClientForm = _j[1];
    var _k = useState(false), clientFormModalOpen = _k[0], setClientFormModalOpen = _k[1];
    function editPet(pet) {
        console.log('editPet...');
        petForm.setData(__assign(__assign({}, form.data), pet));
        setOpen(true);
    }
    function addPet() {
        petForm.setData({});
        setOpen(true);
    }
    function addClientForm() {
        setNewClientForm({ client: client });
        setClientFormModalOpen(true);
    }
    function editClientForm(clientForm) {
        setNewClientForm(clientForm);
        setClientFormModalOpen(true);
    }
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('showClientForm')) {
            var clientForm = _.find(client.client_forms, { id: parseInt(params.get('showClientForm'), 10) });
            console.log('showClientForm', clientForm);
            if (clientForm) {
                editClientForm(clientForm);
            }
        }
    });
    return (_jsxs(AppLayout, __assign({ title: "Client", pageTitle: client.name, breadCrumb: _jsx(Breadcrumb, { team: team, branch: branch, tab: "clients", client: client, current: client.name }) }, { children: [_jsxs("div", __assign({ className: "mt-6" }, { children: [_jsxs("div", __assign({ className: "md:flex" }, { children: [_jsxs("div", __assign({ className: "md:w-1/2 space-y-6 mb-6" }, { children: [_jsx("h2", __assign({ className: "text-lg font-bold" }, { children: "Details" })), _jsx(ClientFields, { form: form }), _jsx("div", { children: _jsxs("button", __assign({ id: "submit", onClick: submit, type: "button", disabled: form.processing, className: "disabled:bg-gray-400 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500" }, { children: [!form.processing && "Save", form.processing && "Saving..."] })) }), _jsxs("table", __assign({ className: "min-w-full divide-y divide-gray-200 mt-4" }, { children: [_jsx("thead", __assign({ className: "bg-gray-50" }, { children: _jsxs("tr", { children: [_jsx("th", __assign({ scope: "col", className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, { children: "Status" })), _jsx("th", __assign({ scope: "col", className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, { children: "Download" })), _jsx("th", __assign({ scope: "col", className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, { children: "Created" })), _jsx("th", { scope: "col", className: "relative px-6 py-3" })] }) })), _jsxs("tbody", { children: [client.certificates.map(function (certificate, certificateIdx) {
                                                        return _jsx(CertificateRow, { hideClientName: true, certificate: certificate, branch: branch, team: team, onDelete: function () { }, className: certificateIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50' }, certificate.uuid);
                                                    }), ((_b = client.certificates) === null || _b === void 0 ? void 0 : _b.length) === 0 && _jsx("tr", { children: _jsx("td", __assign({ colSpan: 4, className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-center" }, { children: _jsx("em", { children: "No certificates..." }) })) })] })] }))] })), _jsxs("div", __assign({ className: "md:w-1/2 mb-6 md:ml-8" }, { children: [_jsxs("div", __assign({ className: "border rounded-lg p-4 mb-8" }, { children: [_jsxs("h2", __assign({ className: "flex items-center justify-between" }, { children: [_jsx("div", __assign({ className: "font-bold" }, { children: "Scheduled appointments" })), _jsxs("button", __assign({ id: "add_client_form", onClick: function () { return addClientForm(); }, type: "button", className: "disabled:bg-gray-400 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500" }, { children: [_jsx(DocumentTextIcon, { className: "w-5 h-5 inline-block mr-2" }), "Schedule AHC"] }))] })), _jsx("div", { children: _jsx("table", __assign({ className: "w-full mt-2" }, { children: _jsx("tbody", { children: form.data.client_forms && form.data.client_forms.map(function (clientForm, i) {
                                                            return _jsxs("tr", __assign({ className: "text-sm border-t" }, { children: [_jsx("td", __assign({ className: "py-2 px-2" }, { children: clientForm.appointment_date ? moment(clientForm.appointment_date).format('D MMM YYYY') : _jsx("em", { children: "No appointment date" }) })), _jsx("td", __assign({ className: "py-2 px-2 text-right" }, { children: _jsx("button", __assign({ className: "text-blue-600", onClick: function () { return editClientForm(clientForm); } }, { children: "Edit" })) }))] }), i);
                                                        }) }) })) })] })), _jsxs("div", __assign({ className: "flex justify-between" }, { children: [_jsx("h2", __assign({ className: "text-lg font-bold" }, { children: "Pets" })), _jsx("button", __assign({ id: "add_pet", onClick: addPet, type: "button", className: "disabled:bg-gray-400 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500" }, { children: "Add pet" }))] })), (_c = form.data.pets) === null || _c === void 0 ? void 0 : _c.map(function (pet, petIdx) {
                                        return _jsx("div", __assign({ className: "mt-6" }, { children: _jsx(PetCard, { pet: pet, deletePet: function () {
                                                    if (confirm("Are you sure you want to delete ".concat(pet.name, "?"))) {
                                                        removePet(petIdx);
                                                    }
                                                }, setEditing: function (editing) {
                                                    editPet(pet);
                                                    if (!editing && !pet.id) {
                                                        removePet(petIdx);
                                                    }
                                                } }) }));
                                    }), ((_e = (_d = form.data) === null || _d === void 0 ? void 0 : _d.pets) === null || _e === void 0 ? void 0 : _e.length) === 0 && _jsx("div", { children: _jsx("div", __assign({ className: "py-6" }, { children: _jsx("em", { children: "No pets..." }) })) })] }))] })), _jsx(JetModal, __assign({ isOpen: clientFormModalOpen, onClose: function () { setClientFormModalOpen(false); } }, { children: _jsx(ClientFormModal, { team: team, branch: branch, clientForm: newClientForm, onClose: function () { setClientFormModalOpen(false); } }) }))] })), _jsx(JetModal, __assign({ isOpen: open, onClose: function () { return setOpen(false); } }, { children: _jsx(PetCardForm, { pet: petForm.data, setEditing: function (editing) {
                        setOpen(false);
                    }, onSave: function (data) {
                        onPetUpdate(data);
                        setOpen(false);
                    }, team: team, branch: branch, client: client, colours: colours, breeds: breeds }) }))] })));
}
